module.exports = __webpack_public_path__ + "img/5.c497aac5.jpg";